import React, { useEffect } from "react";
import CommonCard from "../reusableComponents/components/generics/CommonCard";
import theme from "../utils/theme";
import { ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  documentsSearch,
  fetchContributionPlanByID,
  fetchPolicyHolderInfo,
} from "../action";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { bankOptions } from "../utils/constant";

function PolicyholderReview({ phId, handleDocumnetView }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const userData = useSelector((state) => state.profileReducer);
  useEffect(() => {
    if (userData?.policyholderUserResponseData) {
      dispatch(
        documentsSearch(
          userData?.policyholderUserResponseData?.[0]?.policyHolder
        )
      );
    }
    if (userData?.currentUserResponseData?.id) {
      dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
    }
  }, []);
  useEffect(() => {
    if (userData?.policyholderUserResponseData?.[0]?.policyHolder?.id) {
      dispatch(
        fetchContributionPlanByID(
          userData?.policyholderUserResponseData?.[0]?.policyHolder?.id
        )
      );
      // unwrapJSONFields(policyholderUserData);
    }
  }, [userData?.policyholderUserResponseData?.[0]?.policyHolder?.id]);

  const legalFormVal = [
    {
      value: "1",
      label: t("legalAssoc"),
    },
    {
      value: "2",
      label: t("legalSASAU"),
    },
    {
      value: "3",
      label: t("legalConfession"),
    },
    {
      value: "4",
      label: t("legalCollectivité"),
    },
    {
      value: "5",
      label: t("legalCoopérative"),
    },
    {
      value: "6",
      label: t("legalÉtablissement"),
    },
    {
      value: "7",
      label: t("legalÉtablissementPublic"),
    },
    {
      value: "8",
      label: t("legalFondation"),
    },
    {
      value: "9",
      label: t("legalOrganisation"),
    },
    {
      value: "10",
      label: t("legalSARLU"),
    },
    {
      value: "11",
      label: t("legalAutre"),
    },
  ];

  const ActivityCode = [
    {
      value: "1",
      label: t("activityAgriculture"),
      code: "AEP",
    },
    {
      value: "2",
      label: t("activityBanques"),
      code: "BAM",
    },
    {
      value: "3",
      label: t("activityBâtiment"),
      code: "BTP",
    },
    {
      value: "4",
      label: t("activityCommerces"),
      code: "COM",
    },
    {
      value: "5",
      label: t("activityEnvironnement"),
      code: "ENV",
    },
    {
      value: "6",
      label: t("activityExploitation"),
      code: "EXF",
    },
    {
      value: "7",
      label: t("activityHôtelleries"),
      code: "HER",
    },
    {
      value: "8",
      label: t("activityIndustries"),
      code: "IND",
    },
    {
      value: "9",
      label: t("activityJeux"),
      code: "JEL",
    },
    {
      value: "10",
      label: t("activityMines"),
      code: "MIS",
    },
    {
      value: "11",
      label: t("activityPétrole"),
      code: "PET",
    },
    {
      value: "12",
      label: t("activityParapétrolier"),
      code: "PPT",
    },
    {
      value: "13",
      label: t("activityProjet"),
      code: "PRJ",
    },
    {
      value: "14",
      label: t("activitySanté"),
      code: "SEM",
    },
    {
      value: "15",
      label: t("activityServices"),
      code: "SER",
    },
    {
      value: "16",
      label: t("activityTransport"),
      code: "TEL",
    },
    {
      value: "17",
      label: t("activityTélécom"),
      code: "TEN",
    },
    {
      value: "18",
      label: t("activityAutre"),
      code: "AUT",
    },
  ];

  const policyholderUserData =
    userData?.policyholderUserResponseData?.[0]?.policyHolder;

  const documentData = userData?.documentData;

  const getActivityCodeVAl = (val) => {
    const activity = ActivityCode.find((activity) => activity.value == val);
    return activity ? activity.label : "";
  };

  const getLegaleVal = (val) => {
    const legalFormLabel = legalFormVal.find(
      (legalForm) => legalForm.value == val
    );
    return legalFormLabel ? legalFormLabel.label : "";
  };
  const getBankVal = (val) => {
    const bankLabel = bankOptions.find((bank) => bank.value == val);
    return bankLabel ? bankLabel.label : "";
  };
  const labels = [
    t("camuCode"),
    t("Contact Name"),
    t("NIU"),
    t("RCCM"),
    t("Address"),
    t("Department"),
    t("City"),
    t("Municipality"),
    t("Village"),
    t("Trade Name"),
    t("Main Activity"),
    t("Short Name"),
    t("Created Date"),
    t("Created At"),
    t("No. of Employees"),
    t("Phone"),
    t("Email"),
    t("Legal Form"),
    t("Activity Code"),
    t("Contribution Plan Bundle"),
  ];
  const labels2 = [
    t("Bank"),
    t("Bank Code"),
    t("RIB Key"),
    t("Bank Locker Code"),
    t("Bank Account No"),
  ];
  const labels3 = ["RCCM", "NIU", "EMPLOYEE DECLARATION"];

  const data = labels.map((label) => ({
    label,
    value: policyholderUserData
      ? policyholderUserData.code && label === t("camuCode")
        ? policyholderUserData.code
        : label === t("Contact Name")
        ? policyholderUserData.contactName &&
          JSON.parse(policyholderUserData.contactName)?.contactName
        : label === t("NIU")
        ? JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.niu
        : label === t("RCCM")
        ? JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.rccm
        : label === t("Address")
        ? JSON.parse(policyholderUserData.address)?.address
        : label === t("Department")
        ? policyholderUserData.locations?.parent?.parent?.parent?.name
        : label === t("City")
        ? policyholderUserData.locations?.parent?.parent?.name
        : label === t("Municipality")
        ? policyholderUserData.locations?.parent?.name
        : label === t("Village")
        ? policyholderUserData.locations?.name
        : label === t("Trade Name")
        ? policyholderUserData.tradeName
        : label === t("Main Activity")
        ? JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.mainActivity
        : label === t("Short Name")
        ? JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.shortName
        : label === t("Created Date")
        ? new Date(policyholderUserData.dateValidFrom).toLocaleDateString()
        : label === t("Created At")
        ? !!JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.createdAt?.name
          ? JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.createdAt?.name
          : JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.createdAt
        : label === t("No. of Employees")
        ? JSON.parse(policyholderUserData.jsonExt)?.jsonExt?.nbEmployees
        : label === t("Phone")
        ? policyholderUserData.phone
        : label === t("Email")
        ? policyholderUserData.email
        : label === t("Legal Form")
        ? policyholderUserData.legalForm &&
          getLegaleVal(policyholderUserData.legalForm)
        : label === t("Activity Code")
        ? policyholderUserData.activityCode &&
          getActivityCodeVAl(policyholderUserData.activityCode)
        : label === t("Contribution Plan Bundle")
        ? userData.contributionPlanByIdResponseData?.[0]?.contributionPlanBundle
            ?.name
        : "" // Default value if property not found
      : null,
  }));

  const data2 = labels2.map((label) => ({
    label,
    value: policyholderUserData
      ? label === t("Bank")
        ? JSON.parse(policyholderUserData.bankAccount)?.bankAccount?.bank &&
          getBankVal(
            JSON.parse(policyholderUserData.bankAccount)?.bankAccount?.bank
          )
        : label === t("Bank Code")
        ? JSON.parse(policyholderUserData.bankAccount)?.bankAccount?.bank
        : label === t("RIB Key")
        ? JSON.parse(policyholderUserData.bankAccount)?.bankAccount?.bankKey
        : label === t("Bank Account No")
        ? JSON.parse(policyholderUserData.bankAccount)?.bankAccount?.accountNb
        : label === t("Bank Locker Code")
        ? JSON.parse(policyholderUserData.bankAccount)?.bankAccount?.lockerCode
        : label === t("Bank Account No")
        ? JSON.parse(policyholderUserData.bankAccount)?.bankAccount?.accountNb
        : ""
      : null, // Default value if property not found
  }));

  const data3 = documentData
    ? documentData.map((doc) => ({
        label: t(doc.documentName),
        value: doc.documentPath,
        onClick: () => handleDocumnetView && handleDocumnetView(doc),
      }))
    : null;
  return (
    <Grid container>
      <CommonCard headerTitle={t("General Information")} data={data} />
      <CommonCard headerTitle={t("Bank Details")} data={data2} />
      {documentData && (
        <CommonCard headerTitle={t("Documents")} data={data3} itemsPerRow={1} />
      )}
    </Grid>
  );
}

export default PolicyholderReview;
